import { call, put } from "redux-saga/effects";

import Api from "common/api";
import constants from "./constants";
import moment from "moment";

export default {
  ListSearchCampaign: function* (data) {
    const __name = constants.LIST_SEARCH_CAMPAIGN;
    console.log("data", data);
    try {
      const res = yield call(
        Api.ListSearchCampaign,
        data.token,
        data.adsId,
        data.startDate,
        data.endDate,
        data.orderBy,
        data.orderType,
        data.start,
        data.limit,
        moment().utcOffset(),
      );
      console.log(res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  ListTopKeyword: function* (data) {
    const __name = constants.LIST_TOP_KEYWORD;
    console.log("data", data);
    try {
      const res = yield call(
        Api.ListTopKeyword,
        data.token,
        data.adsId,
        data.startDate,
        data.endDate,
        data.orderBy,
        data.orderType,
      );
      console.log(res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  ListDisplayCampaign: function* (data) {
    const __name = constants.LIST_DISPLAY_CAMPAIGN;
    // console.log('data', data)
    try {
      const res = yield call(
        Api.ListDisplayCampaign,
        data.token,
        data.adAccountId,
        data.startDate,
        data.endDate,
        data.orderBy,
        data.start,
        data.limit,
      );
      console.log(res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  ListTopAudience: function* (data) {
    const __name = constants.LIST_TOP_AUDIENCE;
    console.log("data", data);
    try {
      const res = yield call(
        Api.ListTopAudience,
        data.token,
        data.adAccountId,
        data.startDate,
        data.endDate,
        data.orderBy,
        data.start,
        data.limit,
      );
      console.log(res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  ListTopPlacement: function* (data) {
    const __name = constants.LIST_TOP_PLACEMENT;
    console.log("data", data);
    try {
      const res = yield call(
        Api.ListTopPlacement,
        data.token,
        data.adAccountId,
        data.startDate,
        data.endDate,
        data.orderBy,
        data.start,
        data.limit,
      );
      console.log(res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
